<template>
    <div>
        <vx-card title="" no-shadow card-border id="" class="mt-base">
            <div class="flex items-end">
                <feather-icon icon="ActivityIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Tipo y Estado del Proyecto</span>
            </div>

            <vs-divider/>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <label class="ml-2 text-sm opacity-100">CODIGO UNICO</label>
                    <div class="w-full mb-2 vx-col md:w-1/2">
                        <vs-input class="w-full font-bold text-dark" readonly v-model="inputCUI" v-validate="'required|numeric'" name="codigo" placeholder="Codigo único o SNIP"/>
                        <span class="text-sm text-danger" v-show="errors.has('codigo')">{{ errors.first('codigo') }}</span>
                    </div>
                </div>
            </div>

            <div class="w-full vx-col">
                <label class="ml-2 text-sm opacity-100">Nombre de la Inversión</label>
                <div class="w-full vx-col">
                    <vs-textarea class="w-full" v-model="inputNombreInversion" v-validate="'required'" name="nombre" placeholder="Ingrese nombre de la Inversión"/>
                    <span class="text-sm text-danger" v-show="errors.has('nombre')">{{ errors.first('nombre') }}</span>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="vx-row">
                        <div class="w-full mb-2 vx-col md:w-1/4">
                            <label class="ml-2 text-sm opacity-100">Codigo UEI</label>
                            <vs-input class="w-full" v-model="inputUei" v-validate="''" name="codigo-uei" placeholder="Ingrese UEI"/>
                            <span class="text-sm text-danger" v-show="errors.has('codigo-uei')">{{ errors.first('codigo-uei') }}</span>
                        </div>
                        <div class="w-full mb-2 vx-col md:w-3/4">
                            <label class="ml-2 text-sm opacity-100">Unidad Ejecutora de Inversiones (UEI)</label>
                            <vs-input class="w-full" v-model="inputUeiDescripcion" v-validate="''" name="uei" placeholder="Ingrese UEI"/>
                            <span class="text-sm text-danger" v-show="errors.has('uei')">{{ errors.first('uei') }}</span>
                        </div>
                    </div>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <vs-button 
                    @click="actualizarUEI" 
                    icon-pack="feather" 
                    color="rgb(62, 201, 214)" 
                    icon="icon-refresh-cw"
                    class="mt-6 vs-con-loading__container" 
                    id="button-update-uei-with-loading">
                        Actualizar
                    </vs-button>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-1/2">
                    <div class="mb-2">
                        <label class="ml-2 text-sm opacity-100">Modalidad de Ejecución</label>
                        <v-select :options="itemsModalidad" v-model="selectedModalidad" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="modalidad">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('modalidad')">{{ errors.first('modalidad') }}</span>
                    </div>
                </div>
            </div>

            <div class="w-full mt-2 vx-col">
                <div class="flex flex-wrap items-center justify-start">
                    <vs-button @click="guardar" icon-pack="feather" color="primary" icon="icon-save" class="mt-2 ml-auto">Guardar</vs-button>
                    <vs-button @click="regresar" icon-pack="feather" color="warning" icon="icon-rotate-ccw" class="mt-2 ml-4">Regresar</vs-button>
                    <vs-button @click="limpiar" icon-pack="feather" color="danger" type="border" icon="icon-trash"  class="mt-2 ml-4">Limpiar</vs-button>
                </div>
            </div>

        </vx-card>
    </div>
</template>
<script>
import vSelect from 'vue-select';

export default {
    components: {
        'v-select': vSelect
    },

    data(){
        return {
            parametro               : null,

            inputCUI                : null,
            inputNombreInversion    : null,

            inputUei                : null,
            inputUeiDescripcion     : null,

            selectedModalidad       : null,
            itemsModalidad           : [],

            backgroundLoading       : 'primary',
            colorLoading            : '#fff',
        }
    },

    created(){
        this.parametro = this.$route.params.id;
    },

    mounted(){
        this.getProyecto(this.parametro);
        this.listarEstadoModalidad();
    },

    methods: {
        getProyecto(value){
            this.$vs.loading();
            this.$http.fetchEstados(value)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.loadData(response.data);
                }
            })
            .catch(error => {
                console.log(error);
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEstadoModalidad(){
            this.$vs.loading();
            this.$http.fetchModalidad()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsModalidad = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        loadData(data){
            this.inputCUI               = data.avance.cui;
            this.inputNombreInversion   = data.avance.nombre;
            this.inputUei               = null;
            this.inputUeiDescripcion    = data.estado.uei !== null ? data.estado.uei : null;
            this.selectedModalidad      = data.estado.modalidad !== null ? { value: data.estado.modalidad.id, label: data.estado.modalidad.descripcion } :  null;
        },

        actualizarUEI(){
            this.$vs.loading({
                background: 'rgb(62, 201, 214)',
                color: this.colorLoading,
                container: "#button-update-uei-with-loading",
                scale: 0.45
            });
            this.$http.actualizarUei(this.inputCUI)
            .then(response => {
                this.$vs.loading.close("#button-update-uei-with-loading > .con-vs-loading")
                if(response.status === 200){
                    if(response.data !== null){
                        this.inputUei = response.data.id;
                        this.inputUeiDescripcion = response.data.descripcion;
                    }
                }
            })
            .catch(error => {
                this.$vs.loading.close("#button-update-uei-with-loading > .con-vs-loading")
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        guardar(){
            if(this.inputCUI === null){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'warning',
                    title: `Aviso`,
                    text: 'El campo de CUI del PIP es obligatorio',
                    acceptText: 'Aceptar',
                });
                return;
            }
            const payload = {
                cui: this.inputCUI,
                data: {
                    cui: this.inputCUI,
                    modalidad: this.selectedModalidad !== null ? { id: this.selectedModalidad.value, descripcion: this.selectedModalidad.label } : null,
                }
            };

            this.$vs.loading();
            this.$http.updateEstados(payload)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.regresar();
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        limpiar(){
            this.selectedGestion         = null;
            this.selectedElabExpediente  = null;
            this.selectedModalidad       = null;
            this.selectedDirecta         = null;
            this.selectedContrato        = null;
            this.selectedOxi             = null;
        },

        regresar(){
            this.$router.push({
				name: 'app-parametro-proyecto'
			}).catch(() => {});
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }
}
</script>